import { useState } from "react";
import SettingsAPI from "../api/SettingsAPI";

const useSubmitConflictResolution = () => {
	const [loading, setLoading] = useState(false);

	const submitConflictResolution = async (payload) => {
		setLoading(true);
		const data = {
			data: payload,
		};
		try {
			const result = await SettingsAPI.finalizeImportBOB(data);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to solve conflict:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		submitConflictResolution,
		loading,
	};
};

export default useSubmitConflictResolution;
